export default "__VITE_ASSET__Z6F0uji___"